import Layout from '@/components/layout/Layout.vue'
import CreateForm from '@/views/sys/team/create/Create.vue'
import { getTeams } from '@/api/team'
import { getCorporations } from '@/api/open'
import TeamTargetPage from '@/views/sys/team/team-target/TeamTarget.vue'
import { getUser } from '@/api/user'

export default {
    name: 'teams',
    components: {
        CreateForm,
        Layout,
        TeamTargetPage,
    },
    data() {
        return {
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            corporations: [],
            medias: [],
            selectedRowKeys: [],
            columns: [
                { title: 'ID', dataIndex: 'id', fixed: 'left' },
                { title: '名称', dataIndex: 'name', fixed: 'left' },
                { title: '组内优化师', dataIndex: 'workers', scopedSlots: { customRender: 'workers' } },
                {
                    title: '所属主体', dataIndex: 'corporation_id', customRender: id => {
                        return this.$helper.getItemName(this.corporations, id) || '-'
                    }
                },
                { title: '操作', dataIndex: '', fixed: 'right', scopedSlots: { customRender: 'action' } }
            ],
            model: {},
            queryParam: {},
            showForm: false,
            showTeamTargetPage: false,
        }
    },
    created() {

        getUser().then(res => {
            this.$store.commit('setAdmin', res.data)
            if (this.accessToTeamTarget('stat')) {
                this.columns.splice(4, 0, {
                    title: '今日实时消耗',  customRender: item => {
                        if (!item.day_stat) {
                            return '-'
                        }
                        return item.day_stat.total_cost || '-'
                    }
                });
                this.columns.splice(5, 0, {
                    title: '今日实时roi',  customRender: item => {
                        if (!item.day_stat) {
                            return '-'
                        }
                        let roi = item.day_stat.total_cost > 0 && item.day_stat.total_income > 0 ? Number(item.day_stat.total_income / item.day_stat.total_cost * 100).toFixed(2) : '-'
                        return  !isNaN(roi) ? (roi >= 100 ? <span style="color:red">{roi}%</span> : <span style="color:green">{roi}%</span>) : '-'
                    }
                });
                // this.columns.splice(6, 0, {
                //     title: '本月完成进度', customRender: row => {
                //         if (!row.month_stat) {
                //             return '-'
                //         }
                //         //本月消耗 / 本月目标
                //         let progress = row.month_stat.total_cost > 0 && row.month_target > 0 ? Number(row.month_stat.total_cost / row.month_target * 100).toFixed(2) : '-'
                //         return  !isNaN(progress) ? (progress >= 100 ? <span style="color:red">{progress}%</span> : <span style="color:green">{progress}%</span>) : '-'
                //     }
                // });
                this.columns.splice(6, 0,  {  width:180,title: '本月完成进度', dataIndex: 'month_progress' , scopedSlots: { customRender: 'month_progress' } });
                this.columns.splice(7, 0, { title: '本月排名', dataIndex: 'month_rank' });
            }
        })
     
    },
    mounted() {
        getCorporations().then(res => { this.corporations = res.data.list || {} })
        this.getData()
    },
    methods: {
        create(record) {
            this.model = record.id ? Object.assign({}, record) : {
                media_corporations:[],
                corporation_id:null,
            }
            this.showForm = true
        },
        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })
            getTeams(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('TeamController', route)
        },
        accessToTeamTarget(route) {
            return this.$helper.accessTo('TeamTargetController', route)
        },
        showTeamTarget(record) {
            this.model = { team_id: record.id, name: record.name }
            this.showTeamTargetPage = true
        },
    }
}
